import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xhktv33sen: FaireBrandEntity = {
  token: "b_xhktv33sen",
  type: "brand",
  name: "Chronicle Books",
  avatarUrl:
    "https://cdn.faire.com/fastly/b09aee95d1aa7a3cd5ce25862d78b3f15a16aca80df23c7de572680412c94ece.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8f3e4fa3eca2a9bac35e20549e6bca5318f12fa42c63ce2afd3825732cf74df1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b09aee95d1aa7a3cd5ce25862d78b3f15a16aca80df23c7de572680412c94ece.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8f3e4fa3eca2a9bac35e20549e6bca5318f12fa42c63ce2afd3825732cf74df1.jpeg",
  location: "San Francisco, CA, USA",
  minimumOrderDollars: 250,
  rating: 4.9,
  reviewCount: 722,
  isTopShop: true,
  isInsider: true,
  description:
    "Chronicle Books is an independent publisher based in San Francisco that has been making things since the Summer of Love. We are inspired by the enduring magic of books, and by sparking the passions of others.\n\nAs soon as you pick up our publishing, we want you to be able to tell that what you're holding comes from us. We consider every detail, and ask questions like these: does the design support and enhance the content? How does it feel in your hands? What special touches can we add to make it an object you'll treasure? We apply this approach to everything we make, whether it’s a book, journal, game, ebook, or our newest invention.\n\nWe’ve often been told \"I see your books everywhere\" and that’s just how we like it—you'll find our telltale spectacles on store shelves of all kinds, all over the world. Once you start looking, you can’t miss us. Wherever you are, we invite you to see things differently too.\n \nWe are fortunate to be a premiere distribution house so that you can buy all your favorite brands under one umbrella. With your Chronicle Books order, you can include these stellar brands as part of one amazing order: Galison, Mudpuppy, Brass Monkey, Laurence King, Hardie Grant, Quadrille, the Creative Company, Levine Querido, and Twirl.",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:18:09.126Z",
    importedBy: "entity-db-cli",
  },
};
